import { render, staticRenderFns } from "./LandingPageListChrome.vue?vue&type=template&id=efaf802a&scoped=true&"
import script from "./LandingPageListChrome.vue?vue&type=script&lang=js&"
export * from "./LandingPageListChrome.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageListChrome.vue?vue&type=style&index=0&id=efaf802a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf802a",
  null
  
)

export default component.exports